<template>
  {{ displayNumber }}
</template>

<script setup>
import { onMounted, ref, watch } from 'vue'
const interval = ref(false)
const displayNumber = ref(0)

const props = defineProps({
  number: {
    type: Number,
    default: 0
  }
})

onMounted(() => {
  displayNumber.value = props.number ? props.number : 0
})

watch(props, () => {
  clearInterval(interval.value)
  if (props.number === displayNumber.value) {
    return
  }
  interval.value = window.setInterval(() => {
    if (displayNumber.value !== props.number) {
      let change = (props.number - displayNumber.value) / 10
      change = change >= 0 ? Math.ceil(change) : Math.floor(change)
      displayNumber.value = displayNumber.value + change
    }
  }, 400)
})
</script>
